import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-2" }
const _hoisted_2 = { class: "row m-2" }
const _hoisted_3 = { class: "col-12 mt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add Pharmacy ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientPharmacy = _resolveComponent("PatientPharmacy")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_FormSection, {
      title: "Pharmacy",
      fullHeight: false
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientDetails.pharmacies, (pharmacy, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 col-md-4",
              key: index
            }, [
              _createVNode(_component_PatientPharmacy, {
                "pharmacy-id": pharmacy,
                "provider-id": _ctx.patientDetails.providerId,
                onUpdatePharmacyId: ($event: any) => (_ctx.updatePharmacyId(index, $event))
              }, null, 8 /* PROPS */, ["pharmacy-id", "provider-id", "onUpdatePharmacyId"])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewPharmacy()))
            }, _hoisted_6)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}